import { render, staticRenderFns } from "./HorarioAulaInstrutor.vue?vue&type=template&id=37e88958&scoped=true"
import script from "./HorarioAulaInstrutor.vue?vue&type=script&lang=js"
export * from "./HorarioAulaInstrutor.vue?vue&type=script&lang=js"
import style0 from "./HorarioAulaInstrutor.vue?vue&type=style&index=0&id=37e88958&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e88958",
  null
  
)

export default component.exports